import { Box, Typography } from '@mui/material'
import {createTheme, ThemeProvider, useTheme} from '@mui/material/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'
import imacmonitor from '../../images/iMacMonitor.png'
import vcplogo from '../../images/VCPLogo.png'

const layoutInnerCustomTheme = (outerTheme) => {
    return createTheme({
        ...outerTheme,
        palette: {
            mode: "light",
            ...outerTheme.palette
        },
        components: {
            MuiInput: {
                styleOverrides: {
                    root: {
                        color: "black",
                        ":before": {
                            borderColor: "#313031"
                        }
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: "#313031"
                    }
                }
            }
        }
    })
}

const AuthLayout = ({children, hideLogo}) => {
    const {t} = useTranslation()
    const outerTheme = useTheme()
    
    const containerStyles = {
        display: 'flex',
        minHeight: '100vh'
    }

    const halfInnerStyles = {
        width: '50%',
        minHeight: '100vh',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "20px",
        padding: "40px 20px"
    }

    const vcpLogoStyle = {
        width: '160px',
        position: 'absolute',
        top: '20px',
        left: '50%',
        transform: 'translate(-50%)'
    }

    return (
        <div style={containerStyles}>
            <Box sx={{background: "url(/images/loginside.png) ,rgba(255,255,255,.1)", backgroundPosition: "center", backgroundSize: "cover", ...halfInnerStyles, width: {xs: '100%', md: '100%', lg: '50%'}}}>
                <ThemeProvider theme={layoutInnerCustomTheme(outerTheme)}>
                    {children}
                </ThemeProvider>
            </Box>
            {!hideLogo && <Box sx={{...vcpLogoStyle, display: {xs: 'none', md: 'none', lg: 'flex'}}}><img src={vcplogo} style={{width: '160px'}} alt="" /></Box>}
            <Box sx={{background: "url(/images/logincarouselside.png) ,linear-gradient(30.84deg, #016AFE 61.34%, rgba(1, 163, 254, 0.53) 100%)", ...halfInnerStyles, display: {xs: 'none', md: 'none', lg: 'flex'}}}>
                <Typography maxWidth="460px" textAlign="center" variant="h4" textTransform="uppercase">{t("views.signup.weMake")}</Typography>
                <Typography maxWidth="460px" textAlign="center" variant="h2" textTransform="uppercase">{t("views.signup.digitalSign")}</Typography>
                <Typography maxWidth="460px" textAlign="center" variant="body1">{t("views.signup.impressCustomers")}</Typography>
                <img src={imacmonitor} alt="" style={{width: '350px'}} />
                <Typography maxWidth="460px" textAlign="center" variant='body2'>{t("views.signup.liveScrolling")}</Typography>
            </Box>
        </div>
    )
}

export default AuthLayout
